import { ImmigrationStepService } from '../../../immigration-step.service';
import { CommonService } from 'src/app/core/common.service';
import { StepType } from 'src/app/shared/shared.module';
import {
  getInputField, setAsRequired, setRegexValidation,
  getSelectField, setAsRequiredEmail, getTypeAheadField,
  getDateField, checkRange,
  setAsNumeric, setYesNoValues,
  setRequiredWhen
} from 'src/app/shared/form';
import { VisaType } from '../../visatypes';
import { isNullOrUndefined } from '../../../../../../app/core/utils';
import { FieldTooltip } from '../../field-tooltip.enum';
import { map } from 'rxjs/operators';

export class ExitPermission extends VisaType {
  // exit permission
  GetRequesterSteps(operations?: () => string[]): StepType[] {
    return [
      {
        label: "Step 1",
        fields: [
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              this.EmpProfileSearch(null, operations),

            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              getInputField(
                "gpn",
                "GPN",
                setAsRequired(this.addFieldTooltipWithAdditionalConfig('GPN'))
              ),
              getInputField(
                "gui",
                "GUI",
                setAsRequired(this.addFieldTooltipWithAdditionalConfig('GUI'))
              ),
              //this.gpnGuiSearchButton(operations)
            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              this.firstName(),
              this.middleName(),
              this.lastName()
            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              this.nationalityTypeWithSpecialExpact(),  
              this.nationality(),
              getSelectField(
                "specialExpat",
                "Special Expat",
                setYesNoValues(this.common.getSpecialExpactWrtNationalityType(setAsRequired(this.addFieldTooltipWithAdditionalConfig('special Expat')))
              )),
              this.passportNumber(),
              getSelectField(
                "serviceLine.id",
                "Service line",
                this.common.getSelectFieldOptions(this.serviceLines$, '',
                  setAsRequired())
              ),
              getSelectField(
                "subServiceLine.id",
                "Sub-service line",
                this.common.getSelectFieldOptions(this.subServiceLines$, "serviceLine.id",
                  setAsRequired())
              ),
              this.rank(),
              // this.grade(),
              this.officeLocation(),
              this.officeLE('EY legal entity'),
              this.travelDate(),
              getSelectField(
                "travelPurpose.id",
                "Purpose of travel",
                this.common.getSelectFieldOptions(this.travelPurpose$, '',
                  setAsRequired())),
                  getInputField("permissionDuration", "Permit duration (days)",
                setAsRequired(checkRange(0, 240,
                  "Permit duration should be less than 240",
                  setAsNumeric()))),
            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              getSelectField(
                "entryType.id",
                "Permit type",
                this.common.getSelectFieldOptions(this.entryType$.pipe(map(x => x.filter(l => [5916,5917].includes(l.id)))), '',
                  setAsRequired())),
              getDateField("dateOfPayment", "Date of payment",
                this.addFieldTooltipWithAdditionalConfig('Date of payment',
                setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
                  "Please enter a valid date in 'dd-mm-yyyy' format"))),
              this.residencyStatus(),
              this.iqamaNumber(),
              this.RequestorName()
            ]
          },
        ]
      }];
  }


  GetAccepterSteps(): StepType[] {
    return [
      {
        label: "Step 1",
        fields: [
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              this.visaProcessorByOfficeLE(setAsRequired()),
              // this.Requestor()
            ]
          }
        ]
      }
    ];
  }



  GetApproverSteps(): StepType[] {

    return [
      {
        label: "Step 1",
        fields: [
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              this.visaProcessorByOfficeLE(
                setAsRequired()
                ),
              this.immigrationStatus(),
              // this.Requestor()
            ]
          }
        ]
      }
    ];
  }
}
